import { generatePath, useHistory } from 'react-router-dom';
import Highcharts from 'highcharts';
import HighchartsReact from 'highcharts-react-official';

import type { JobDetails } from '@/api/fe-api/domain/entities/capacity-evaluation';
import type { Site } from '@/api/fe-api/domain/entities/site';
import { GetAllJobs } from '@/api/fe-api/view/queries/capacity-evalution/get-all-jobs';
import { GetSohData } from '@/api/fe-api/view/queries/capacity-evalution/get-soh-data';

import { getSohChartConfig } from './get-soh-chart-config';

export type SectionSohChartProps = {
  capacityTest: JobDetails;
  asset: Site;
};

export function SectionSohChart({ capacityTest, asset }: SectionSohChartProps) {
  const history = useHistory();

  const jobList = GetAllJobs.useQuery({ siteId: asset.id });
  const { data } = GetSohData.useQuery({ assetId: asset.id });
  const sohData = data?.isOk() ? data.value : [];

  function handleCapacityTestClick(jobId: string) {
    history.push({
      pathname: generatePath(`/asset/:assetId/capacity-test/`, {
        assetId: asset.id,
      }),
      search: new URLSearchParams({
        id: jobId,
      }).toString(),
    });
  }

  const options = getSohChartConfig({
    dataPoints: sohData,
    capacityTests:
      jobList.data?.filter((item) => item.status === 'Completed') ?? [],
    endOfLifeThreshold: 80,
    currentCapacityTest: jobList.data?.find(
      (item) => item.id === capacityTest.id,
    ),
    onCapacityTestClick: handleCapacityTestClick,
  });

  return <HighchartsReact highcharts={Highcharts} options={options} />;
}
